import { useEffect, useRef } from 'react';

// Charger guard for tethered devices: yanking the charging cable (grab-and-run) fires the
// panic callback. Only an observed charging → not-charging transition triggers — running on
// battery is inert until the cable is connected. Battery Status API is Chromium-only;
// elsewhere the hook is a no-op.
export const useChargerPanic = (callback, { enabled = true } = {}) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    if (!enabled || typeof navigator.getBattery !== 'function') return;

    let cancelled = false;
    let battery = null;
    let wasCharging = false;

    const onChargingChange = () => {
      if (wasCharging && !battery.charging) {
        battery.removeEventListener('chargingchange', onChargingChange);
        callbackRef.current('unplugged');
        return;
      }
      wasCharging = battery.charging;
    };

    navigator.getBattery().then((manager) => {
      if (cancelled) return;
      battery = manager;
      wasCharging = battery.charging;
      battery.addEventListener('chargingchange', onChargingChange);
    });

    return () => {
      cancelled = true;
      battery?.removeEventListener('chargingchange', onChargingChange);
    };
  }, [enabled]);
};
